export default __webpack_public_path__ + "static/floating-island-004b1f749e30c52152675ce670589897.png";